import { formatInTimeZone } from "date-fns-tz";

import { DIAL_BLOCK_ET_ZONE } from "./constants";

/**
 * The time zone a caller reads their dial blocks in: always the browser's
 * own (Omar, 2026-10-19: "by default, to be local always … I don't want to
 * give that option"). Labels only: every rule stays in ET.
 */

/** US zones a caller is likely to sit in, named the way callers say them. */
const US_ZONE_CODES: Record<string, string> = {
  "America/New_York": "ET",
  "America/Detroit": "ET",
  "America/Toronto": "ET",
  "America/Chicago": "CT",
  "America/Denver": "MT",
  "America/Phoenix": "MT",
  "America/Los_Angeles": "PT",
};

/** Where the retired "Show times in" picker kept its choice. */
export const LEGACY_DISPLAY_TIMEZONE_STORAGE_KEY =
  "glencoco:dial-blocks:display-timezone";

/** The browser's own IANA zone, or ET when the browser won't say. */
export const getDeviceTimezone = (): string => {
  try {
    return (
      Intl.DateTimeFormat().resolvedOptions().timeZone || DIAL_BLOCK_ET_ZONE
    );
  } catch {
    return DIAL_BLOCK_ET_ZONE;
  }
};

/**
 * A short label for `zone` at `at`: ET / CT / MT / PT for the US zones
 * callers use, otherwise the zone's own short name (e.g. "GMT+3").
 */
export const getZoneLabel = (zone: string, at: Date = new Date()): string => {
  const code = US_ZONE_CODES[zone];

  if (code) {
    return code;
  }

  try {
    return formatInTimeZone(at, zone, "zzz");
  } catch {
    return zone;
  }
};

/** Drops the retired picker's saved choice; blocked storage is fine. */
export const clearLegacyDisplayTimezone = () => {
  try {
    window.localStorage.removeItem(LEGACY_DISPLAY_TIMEZONE_STORAGE_KEY);
  } catch {
    // Private mode or blocked storage: nothing was saved there anyway.
  }
};
